import BaseService from './base.service'
import { ENDPOINT } from '~/api/endpoint'

class CommonService extends BaseService {
  constructor(option) {
    super(option)
    return this
  }

  async getMasterData() {

    return {
    }
  }

  /**
   * @description
   * [Danh sách] - Danh sách role
   */
  getUserRole() {
    return this.http.get(ENDPOINT.MASTER_USER_ROLE).then(res => res.data.data)
  }

  /**
   * @description
   * [Danh sách] - Danh sách role
   */
  getUserProfile() {
    return this.http.get(ENDPOINT.MASTER_USER_PROFILE).then(res => res.data.data)
  }

  /**
   * @description
   * [Danh sách] - Danh sách role
   */
  updateUserProfile(data) {
    return this.http.put(ENDPOINT.USER_UPDATE_PROFILE, { data })
      .then(res => res.data.data)
  }

  /**
   * @description
   * [Danh sách] - Danh sách role
   */
  updateUserProfileAdmin(userId, data) {
    return this.http.put(ENDPOINT.USER_UPDATE_PROFILE_ADMIN.replace('{id}', userId), { data })
      .then(res => res.data.data)
  }

  /* Cập nhật vị thuốc */
  updateUserPassword(data) {
    return this.http.put(ENDPOINT.USER_UPDATE_PASSWORD, { data },)
  }

  /**
   * @description
   * [Danh sách] - Danh sách role
   */
  getListMasterRole() {
    return this.http.get(ENDPOINT.MASTER_ROLES).then(res => res.data.data)
  }

   /**
   * @description
   * [Danh sách] -  Danh sách tỉnh
   */
  getListProvince() {
    return this.http.get(
      ENDPOINT.MASTER_PROVINCES).then(res => res.data.data)
  }

   /**
   * @description
   * [Danh sách] -  Quận huyện theo tỉnh
   */
  getDistrictBelongProvince(provinceId) {
    return this.http.get(
      ENDPOINT.MASTER_DISTRICTS.replace('{id}', provinceId)).then(res => {
        const payload = {}
        payload[provinceId] = res.data
        return res.data.data
      }
    )
  }

  /**
   * @description
   *  [Danh sách] - Phường xã theo quận huyện
   */
  getWardsBelongDistrict(districtId) {
    return this.http.get(
      ENDPOINT.MASTER_WARDS.replace('{id}', districtId)).then(res => {
        const payload = {}
        payload[districtId] = res.data
        return res.data.data
      }
    )
  }
  
  /**
   * @description
   *  [Danh sách] - Danh sách tất cả vị thuốc
   */
  getListSearchConditionOrder() {
    return this.http.get(ENDPOINT.MASTER_SEARCH_CONDITION_ORDER)
      .then(res => res.data.data)
  }


  /**
   * @description
   *  [Danh sách] - Danh sách tất cả vị thuốc
   */
  getStatisticInfomation() {
    return this.http.get(ENDPOINT.MASTER_STATISTIC)
      .then(res => res.data.data)
  }

  /**
   * [Hình ảnh] - Upload hình ảnh lên server
  */
  uploadImagesCommon(images) {
    return this.http.post(ENDPOINT.MASTER_UPLOAD_IMAGE, images)
      .then(data => data.data.data)
  }
}

export default new CommonService({ auth: true })
